import React, { Fragment } from 'react';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';


const ReactTableActionsFormula = ({ data, Callback, disabledTextFields, removeFormulaByIndex, dropFromTable, onUpdateFormula }) => {

  return (<Fragment>
    <td role="cell">
      <Tooltip title="Actualizar">
        <IconButton onClick={() => {
          ///Callback();
          onUpdateFormula(data.data.index, data.data.original);
        }}
          disabled={disabledTextFields}
        >
          <EditOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar">
        <IconButton onClick={() => {
          ///Callback();
          removeFormulaByIndex(data.data.index);
          dropFromTable(data.data.index);
        }}
          disabled={disabledTextFields}
        >
          <DeleteForeverIcon />
        </IconButton>
      </Tooltip>

    </td>
  </Fragment>)
}

export default ReactTableActionsFormula;